module.exports = __webpack_public_path__ + "static/media/caseiqmainpage.12f0e420.png";